import type { ClientToServerEvents, ServerToClientEvents } from '@lagerfeuer/shared';
import { io, type Socket } from 'socket.io-client';

export type LfSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/** Typisierte Socket.IO-Verbindung (Pfad /socket.io, Token im Handshake). */
export function createSocket(getToken: () => string | null): LfSocket {
  return io({
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    autoConnect: false,
    auth: (cb) => cb({ token: getToken() ?? '' }),
  });
}
